__webpack_require__.p = "/samurai-way-tsx/";